import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, Info } from 'lucide-react';
import { Button } from '@/components/ui/button';
import PageWrapper from '@/components/PageWrapper';
import { FadeUp } from '@/components/ScrollReveal';

const BookingsPage = () => {
  return (
    <PageWrapper>
      {/* Hero */}
      <section data-testid="bookings-hero" className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <FadeUp>
            <div className="text-center max-w-2xl mx-auto">
              <Calendar className="mx-auto mb-4 text-stone-400" size={32} strokeWidth={1} />
              <p className="text-xs uppercase tracking-[0.2em] text-stone-500 mb-4">Schedule</p>
              <h1 className="font-heading text-5xl sm:text-6xl text-stone-900 leading-[1.1] tracking-tight">
                Make a <span className="italic">Booking</span>
              </h1>
            </div>
          </FadeUp>
        </div>
      </section>

      {/* Booking Info */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <FadeUp>
            <div className="p-6 bg-stone-100 border border-stone-200">
              <div className="flex items-start gap-4">
                <Info className="text-stone-500 flex-shrink-0 mt-1" size={20} strokeWidth={1.5} />
                <div className="space-y-3">
                  <p className="text-stone-700 font-light">
                    <strong className="font-medium">Existing clients</strong> can book sessions directly via the calendar below.
                  </p>
                  <p className="text-stone-500 font-light">
                    <strong className="font-medium text-stone-700">New to TEZR Pilates?</strong> Please request a session via the contact form.
                  </p>
                  <div className="flex flex-wrap gap-3 pt-2">
                    <Button asChild data-testid="bookings-contact-btn" className="btn-primary">
                      <Link to="/contact">
                        Request Session <ArrowRight className="ml-2" size={14} strokeWidth={1.5} />
                      </Link>
                    </Button>
                    <Button asChild variant="outline" data-testid="bookings-faq-btn" className="btn-secondary">
                      <Link to="/faq">View FAQ</Link>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </FadeUp>
        </div>
      </section>

      {/* PTminder Iframe */}
      <section data-testid="booking-calendar" className="py-12 pb-24">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <FadeUp>
            <div className="iframe-container">
              <iframe
                src="https://ottoprodanpt.ptminder.com/"
                title="TEZR Pilates Booking Calendar"
                className="w-full"
                style={{ height: '700px', border: 'none' }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </FadeUp>
        </div>
      </section>
    </PageWrapper>
  );
};

export default BookingsPage;
